import {Injectable}                                                         from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of}                                                     from 'rxjs';
import {
  ApUploadFakeStreamService
}                                                                           from '../services/ap-file-upload-fake-stream.service';
import {APP_CONFIGURATION}                                                  from '../../ap-core/config';
import {FileWithId}                                                         from '../types/ap-file-upload.types';

/**
 * HTTP interceptor that handles file upload requests by providing fake upload streams
 * and managing file removal responses.
 * Intercepts requests to configured upload and remove URLs to simulate file operations.
 */
@Injectable()
export class ApFileUploadInterceptor implements HttpInterceptor {
  constructor(private fileUploadFakeStreamService: ApUploadFakeStreamService) {
  }

  /**
   * Intercepts HTTP requests and handles file upload/remove operations:
   * - For upload requests: Returns a fake upload progress stream
   * - For remove requests: Returns immediate success response
   * - For all other requests: Passes through to next handler
   * @param req The outgoing HTTP request
   * @param next The next handler in the chain
   * @returns Observable of HttpEvents for the request
   */
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === APP_CONFIGURATION.UploadSaveUrl) {
      const formData = req.body as FormData;
      const file = formData.get('files') as FileWithId;
      return this.fileUploadFakeStreamService.getUploadStream(file.uid);
    }
    if (req.url === APP_CONFIGURATION.UploadRemoveUrl) {
      return of(new HttpResponse({status: 200}));
    }
    return next.handle(req);
  }
}
